<template>
  <div class="login">
    <div class="have-token" v-if="token">正在登陆中...</div>
    <div class="not-token" v-else>
      <img :src="require('@/assets/login/background.png')" />
      <img class="login-logo" :src="require('@/assets/login/header.png')" />
      <div class="login-box" v-if="type === 'login'">
        <div class="login-box-from">
          <div class="login-box-from-text">
            <div>帕拉卡数据平台</div>
            <div>愿景： 团结全世界的资源和力量</div>
            <div>共同创建属于每一个人的3D世界</div>
          </div>
          <div class="login-box-from-main">
            <div class="login-box-from-common">
              <el-input v-model="username" placeholder="请输入账号"></el-input>
              <img :src="require('@/assets/login/user.png')" />
            </div>
            <div class="login-box-from-common">
              <el-input
                v-model="password"
                placeholder="请输入密码"
                show-password
                @keyup.native.enter="loginFun"
              ></el-input>
              <img :src="require('@/assets/login/password.png')" />
            </div>
            <div class="login-box-from-forget" @click="toResetBox">
              忘记密码?
            </div>
            <div class="login-box-from-button" @click="loginFun">登 录</div>
          </div>
        </div>
        <div class="login-box-links">
          <a
            href="https://paracraft.cn/"
            target="_blank"
            class="login-box-link"
          >
            <span>官网：</span>
            <span>paracraft.cn</span>
          </a>
          <a href="mailto:support@paraengine.com" class="login-box-link">
            <span>招募通道：</span>
            <span>support@paraengine.com</span>
          </a>
        </div>
      </div>
      <div class="reset-box" v-if="type === 'reset'">
        <div class="reset-box-from">
          <h3>重置密码</h3>
          <el-input
            v-model="phone"
            placeholder="请输入手机号"
            :maxlength="11"
          ></el-input>
          <div class="reset-box-from-code">
            <el-input v-model="code" placeholder="请输入验证码"></el-input>
            <el-button type="primary" @click="getCode" :disabled="disabled"
              >获取验证码</el-button
            >
          </div>
          <el-input
            v-model="newPassword"
            show-password
            placeholder="请输入新密码"
          ></el-input>
          <el-input
            v-model="surePassword"
            placeholder="确认新密码"
            @input="sureNewPassword"
            show-password
          ></el-input>
          <div v-if="flag" class="reset-box-from-hint">
            两次输入的密码不一致
          </div>
          <div class="reset-box-from-sure" @click="sureChangePassword">
            确 认
          </div>
          <div class="reset-box-from-footer">
            <div></div>
            <div>
              已有账号?
              <span @click="toLoginBox">立即登录</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      type: 'login',
      username: '',
      password: '',
      phone: '',
      code: '',
      newPassword: '',
      surePassword: '',
      disabled: false,
      flag: false
    }
  },
  computed: {
    token() {
      return this.$route.query.token
    }
  },
  async created() {
    if (this.token) {
      await this.changeToken(this.token)
      this.$router.push({
        name: 'OverallStat'
      })
    }
  },
  methods: {
    ...mapActions({
      changeToken: 'customer/changeToken',
      login: 'customer/login',
      phoneCaptcha: 'customer/phoneCaptcha',
      resetPass: 'customer/resetPass'
    }),
    sureNewPassword() {
      if (this.newPassword) {
        if (this.surePassword !== this.newPassword) {
          this.flag = true
        } else {
          this.flag = false
        }
      }
      if (!this.surePassword) {
        this.flag = false
      }
    },
    toResetBox() {
      this.type = 'reset'
      this.username = ''
      this.password = ''
    },
    toLoginBox() {
      this.type = 'login'
      this.phone = ''
      this.code = ''
      this.newPassword = ''
      this.surePassword = ''
    },
    async loginFun() {
      if (!this.username) {
        this.$message({
          type: 'warning',
          message: '用户名是必填项'
        })
        return
      }
      if (!this.password) {
        this.$message({
          type: 'warning',
          message: '密码是必填项'
        })
        return
      }
      const params = {
        username: this.username,
        password: this.password
      }
      await this.login(params)
      this.$router.push({
        name: 'OverallStat'
      })
    },
    async getCode() {
      if (!this.phone) {
        this.$message({
          type: 'warning',
          message: '电话号码不能为空'
        })
        return
      }
      if (this.phone.length !== 11) {
        this.$message({
          type: 'warning',
          message: '电话号码是11位的'
        })
        return
      }
      let query = {
        phone: this.phone
      }
      await this.phoneCaptcha(query)
      this.disabled = true
      this.$message({
        type: 'success',
        message: '验证码获取成功，如没有收到消息，60秒后可再次发送'
      })
      this.timer = setTimeout(() => {
        this.disabled = false
      }, 60000)
    },
    async sureChangePassword() {
      if (!this.phone) {
        this.$message({
          type: 'warning',
          message: '电话号码是必填项'
        })
        return
      }
      if (!this.code) {
        this.$message({
          type: 'warning',
          message: '验证码是必填项'
        })
        return
      }
      if (!this.flag) {
        const body = {
          phone: this.phone,
          captcha: this.code,
          password: this.surePassword
        }
        await this.resetPass(body)
        this.$message({
          type: 'success',
          message: '密码重置成功'
        })
        this.toLoginBox()
      } else {
        this.$message({
          type: 'warning',
          message: '两次输入的密码不一致'
        })
      }
    }
  },
  destroyed() {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="scss">
.login {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  .login-logo {
    position: absolute;
    left: 500px;
    top: 110px;
  }
  .login-box {
    position: absolute;
    left: 310px;
    top: 270px;
    height: 570px;
    width: 580px;
    .login-box-from {
      background: url('../../assets/login/login-background.png') no-repeat -32px -32px;
      height: 504px;
      .login-box-from-text {
        padding-top: 50px;
        div {
          text-align: center;
          color: #666666;
          line-height: 28px;
          letter-spacing: 1px;
        }
        div:nth-of-type(1) {
          font-size: 32px;
          color: #409fff;
          line-height: 32px;
          margin-bottom: 20px;
          margin-right: 20px;
          font-weight: bold;
        }
      }
      .login-box-from-main {
        width: 332px;
        box-sizing: border-box;
        margin: 0 auto;
        .login-box-from-common {
          margin-top: 30px;
          position: relative;
          img {
            position: absolute;
            left: 12px;
            top: 8px;
          }
          .el-input__inner {
            padding-left: 44px;
          }
        }
        .login-box-from-forget {
          width: 100%;
          text-align: right;
          font-size: 14px;
          color: #666666;
          margin-top: 4px;
          cursor: pointer;
          &:hover {
            color: #2397f2;
          }
        }
        .login-box-from-button {
          width: 100%;
          height: 40px;
          margin-top: 30px;
          text-align: center;
          font-size: 18px;
          background: url('../../assets/login/login-button.png') no-repeat;
          line-height: 40px;
          cursor: pointer;
          &:hover {
            color: #fff;
          }
        }
      }
    }
    .login-box-links {
      width: 580px;
      position: absolute;
      left: 0px;
      bottom: -20px;
      .login-box-link {
        text-decoration: none;
        display: block;
        text-align: center;
        width: 398px;
        height: 32px;
        margin: 0 auto;
        background: url('../../assets/login/link.png') no-repeat;
        margin-bottom: 20px;
        line-height: 32px;
        span:nth-of-type(1) {
          color: #fff288;
        }
        span:nth-of-type(2) {
          color: white;
        }
        &:hover {
          span:nth-of-type(2) {
            color: black;
          }
        }
      }
    }
  }
  .reset-box {
    position: absolute;
    left: 310px;
    top: 270px;
    background: url('../../assets/login/reset-background.png') no-repeat -32px -32px;
    width: 580px;
    height: 516px;
    box-sizing: border-box;
    padding-top: 40px;
    .reset-box-from {
      width: 332px;
      margin: 0 auto;
      h3 {
        text-align: center;
        color: #409eff;
        font-size: 30px;
      }
      & > .el-input {
        margin-top: 30px;
      }
      .reset-box-from-code {
        margin-top: 30px;
        display: flex;
        .el-input__inner {
          border-right: none;
          border-radius: 4px 0px 0px 4px;
        }
        .el-button {
          border-left: none;
          border-radius: 0px 4px 4px 0px;
        }
      }
      .reset-box-from-hint {
        color: red;
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: -10px;
      }
      .reset-box-from-sure {
        width: 100%;
        height: 40px;
        margin-top: 30px;
        text-align: center;
        font-size: 18px;
        background: url('../../assets/login/login-button.png') no-repeat;
        line-height: 40px;
        cursor: pointer;
        &:hover {
          color: #fff;
        }
      }
      .reset-box-from-footer {
        margin-top: 16px;
        display: flex;
        font-size: 14px;
        justify-content: space-between;
        div:nth-of-type(2) {
          color: #666666;
          span {
            cursor: pointer;
            color: #409eff;
          }
        }
      }
    }
  }
}
</style>
